// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ffx2","col":"styles_col__3Jh94"};